import React, { useEffect } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'

import {
	formatByTimeZone
} from 'utils'

import 'react-big-calendar/lib/css/react-big-calendar.css'

const localizer = momentLocalizer(moment)

export default ({
    date,
    onDateChange,
    eventsThisMonth
}) => {
    const formattedEvents = (() => {
        const response = []

        Object.keys(eventsThisMonth).forEach(key => {
            const eventsInThisGroup = eventsThisMonth[key]

            eventsInThisGroup.forEach(event => {
                if (key === 'tasks') {
                    const start = event.dates.start || event.dates.end
                    const end = event.dates.end

                    response.push({
                        title: event.name,
                        start: formatByTimeZone(start, 'YYYY-MM-DD'),
                        end: formatByTimeZone(end, 'YYYY-MM-DD'),
                        allDay: true,
                        resource: {
                            id: 5,
                            name: 'Zingo bingo',
                            text: 'Test est set'
                        }
                    })
                } else {
                    response.push({
                        title: event.title,
                        start: event.date,
                        end: event.date,
                        resource: {
                            id: 2,
                            name: 'zzz',
                            text: 'sdfsdf'
                        }
                    })
                }
            })
        })

        return response
    })()

    const recalcCellHeight = () => {
        setTimeout(() => {
            const monthRows = document.querySelectorAll('.rbc-month-row')

            if (monthRows && monthRows.length) {
                const monthRowHeight = monthRows[0].getBoundingClientRect().height

                const allCellInner = document.querySelectorAll('.rbc-date-cell a')

                for (let i = 0, len = allCellInner.length; i < len; i++) {
                    allCellInner[i].style.height = monthRowHeight + 'px'
                }
            }
        }, 50)
    }

    useEffect(() => {
        recalcCellHeight()
    }, [])

    useEffect(() => {
        recalcCellHeight()
    }, [date])

    return (
        <div>
            <Calendar
                localizer={localizer}
                date={date}
                events={formattedEvents}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 550 }}
                formats={{
                    dateFormat: 'D'
                }}
                onNavigate={onDateChange}
                selectable={true}
                views={['month']}
            />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/big-calendar/big-calendar.jsx